<template>
    <div class="model__preview">
        <model-icon
            :url="$props.nluModel.imageSrc"
            :default-image="$props.defaultImage"
        />
        <h3 class="title">
            {{$props.nluModel.name}}
        </h3>
        <p class="description" v-if="$props.nluModel.desc">
            {{$props.nluModel.desc}}
        </p>
        <slot name="culture" />
        <div class="actions">
            <div>
              <or-button
                buttonType="button"
                type="secondary"
                class="import--btn btn"
                color="primary"
                icon="file_download"
                :loading="$props.isImporting"
                @click="openImportCsvModal"
              >
                {{ $t('generic.import') }}
              </or-button>
              <or-button
                buttonType="button"
                type="secondary"
                icon="file_download"
                class="export--btn btn"
                color="primary"
                :loading="$props.isExporting"
                @click="$emit('export')"
              >
                {{ $t('generic.export') }}
              </or-button>
            </div>
            <div>
                <or-button
                    buttonType="button"
                    type="primary"
                    class="change-engine--btn"
                    color="primary"
                    @click="$emit('edit')"
                >
                  {{ $t('generic.edit') }}
                </or-button>
            </div>
        </div>
        <div class="delete-btn--wrapper">
          <delete-model-btn
            :modal-title="$t('model.nlu-model.settings.settings-preview.deleteNluModel')"
            :is-deleting="isDeleting"
            @delete="$emit('delete')"
          />
        </div>
      <import-csv-modal
        ref="import-csv-modal"
        :contexts="contextNames"
      />
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { meta_limits as metaLimits } from '@/modules/limits'
import ModelIcon from '../../common/model_icon'
import DeleteModelBtn from '../../common/delete-model-button'
import ImportCsvModal from '@/components/common/modals/import_csv_modal'

export default {
  components: {
    ModelIcon,
    DeleteModelBtn,
    ImportCsvModal
  },

  props: {
    nluModel: {
      type: Object,
      default: () => ({})
    },
    defaultImage: String,
    isDeleting: Boolean,
    isExporting: Boolean,
    isImporting: Boolean
  },

  created () {
    this.fetchAllApplications()
  },

  computed: {
    ...mapState('knowledgebase', ['allApplications']),

    titleMax () {
      return metaLimits ? metaLimits.title.max : 0
    },

    contextNames () {
      return this.allApplications.map(category => ({
        id: category.id,
        name: category.name
      }))
    }
  },

  methods: {
    ...mapActions('knowledgebase', ['fetchAllApplications']),

    openImportCsvModal () {
      this.$refs['import-csv-modal'].openModal()
    }
  }
}
</script>

<style lang="scss" scoped>
    .title {
        margin-bottom: 8px;
        font-size: 18px;
        line-height: 27px;
        font-weight: bold;
    }

    .engine {
        font-size: 14px;
        font-weight: normal;
        color: rgb(145, 150, 157);
    }

    .description {
        word-break: break-word;

        margin-top: 16px;
        color: rgb(30, 35, 43);
        font-size: 14px;
        font-weight: normal;
        line-height: 21px;
    }

    .actions {
        .btn {
          ::v-deep {
            .ui-icon {
              font-size: 20px;
            }
          }
        }
        display: flex;
        justify-content: space-between;
        margin-top: 32px;
        .import--btn {
          ::v-deep {
            .ui-icon {
              transform: rotate(180deg);
            }
          }
        }
        .export--btn {
            margin-left: 16px;
        }
        .change-engine--btn {
            margin-left: 16px;
        }
    }
    .delete-btn--wrapper {
      margin-top: 24px;
    }
</style>
